import React from "react";
import {
  Table, TableHead, TableRow, TableCell,
  TableBody, Box, Button
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchMcqQuestions } from "../../../../redux/Actions/einstufungActions";

const McqTab = ({ setMessage }) => {
  const dispatch = useDispatch();
  const { mcqQuestions, currentPage, totalPages } = useSelector((state) => state.einstufung);

  const handlePageChange = (pageNum) => dispatch(fetchMcqQuestions(pageNum));

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Frage</TableCell>
            <TableCell>Optionen</TableCell>
            <TableCell>Korrekte Antwort</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {mcqQuestions.map((q) => (
            <TableRow key={q.id}>
              <TableCell>{q.questionText}</TableCell>
              <TableCell>
                {q.options?.map((opt, idx) => (
                  <div key={idx}>{opt}</div>
                ))}
              </TableCell>
              <TableCell>{q.correctAnswer}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {totalPages > 1 && (
        <Box mt={2} textAlign="center">
          {[...Array(totalPages)].map((_, i) => (
            <Button
              key={i}
              variant={i === currentPage ? "contained" : "outlined"}
              onClick={() => handlePageChange(i)}
              sx={{ mx: 0.5 }}
            >
              {i + 1}
            </Button>
          ))}
        </Box>
      )}
    </>
  );
};

export default McqTab;
